import Api from './Api';
import Configuracao from '../util/Configuracao';

class AcertoMensalidadeApi extends Api {
  async consultarTodosOsProtocolos () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosProtocolosAcertoMensalidade;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarOrigens () {
    try {
      const origensUrl = Configuracao.getConfiguracao().urlConsultarOrigensAcertoMensalidade;
      const response = await this.fetch(origensUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEstados () {
    try {
      const estadosAcertoUrl = Configuracao.getConfiguracao().urlConsultarEstadosAcertoMensalidade;
      const response = await this.fetch(estadosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarAcertos (numProtocolo, numMatricula, codOrigem, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal) {
    try {
      const acertoUrl = Configuracao.getConfiguracao().urlConsultarAcertosMensalidade +
      numProtocolo + '/' +
      numMatricula + '/' +
      codOrigem + '/' +
      codEstado + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal;
      const response = await this.fetch(acertoUrl, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirAcerto (acerto) {
    try {
      const urlIncluirAcerto = Configuracao.getConfiguracao().urlIncluirAcerto;
      const response = await this.fetch(urlIncluirAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarAcerto (acerto) {
    try {
      const urlAlterarAcerto = Configuracao.getConfiguracao().urlAlterarAcerto;
      const response = await this.fetch(urlAlterarAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcertosEmLote (acertos) {
    try {
      const urlExcluirAcertos = Configuracao.getConfiguracao().urlExcluirAcertos;
      const result = await this.fetch(urlExcluirAcertos, 'post', acertos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async processarAcerto (numProtocolo) {
    try {
      const urlProcessarAcerto = Configuracao.getConfiguracao().urlProcessarAcerto + numProtocolo;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    try {
      const urlCancelarAcerto = Configuracao.getConfiguracao().urlCancelarAcerto + numProtocolo + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    try {
      const urlDesfazerCancelamentoAcerto = Configuracao.getConfiguracao().urlDesfazerCancelamentoAcerto + numProtocolo;
      const response = await this.fetch(urlDesfazerCancelamentoAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async analisarAcerto (numProtocolo) {
    try {
      const urlAnalisarAcerto = Configuracao.getConfiguracao().urlAnalisarAcerto + numProtocolo;
      const response = await this.fetch(urlAnalisarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAcerto (numProtocolo) {
    try {
      const urlExcluirAcerto = Configuracao.getConfiguracao().urlExcluirAcerto + numProtocolo;
      const response = await this.fetch(urlExcluirAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AcertoMensalidadeApi;
